import { useState } from 'react'
import { Card, Typography } from 'antd'
import { FeatureDefinitionList } from '@/components/features/FeatureDefinitionList'
import { FeatureDefinitionWizard } from '@/components/features/FeatureDefinitionWizard'
import type { FeatureDefinition } from '@/types/feature-definition'

const { Title } = Typography

export const FeatureDefinitions = () => {
  const [wizardOpen, setWizardOpen] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [selectedFeature, setSelectedFeature] = useState<FeatureDefinition | undefined>()
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleCreateClick = () => {
    setEditMode(false)
    setSelectedFeature(undefined)
    setWizardOpen(true)
  }

  const handleEditClick = (feature: FeatureDefinition) => {
    setEditMode(true)
    setSelectedFeature(feature)
    setWizardOpen(true)
  }

  const handleWizardClose = () => {
    setWizardOpen(false)
    setEditMode(false)
    setSelectedFeature(undefined)
  }

  const handleWizardSuccess = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  return (
    <div>
      <Title level={2}>Feature Definitions</Title>
      <Card>
        <FeatureDefinitionList
          key={refreshTrigger}
          onCreateClick={handleCreateClick}
          onEditClick={handleEditClick}
          onRefresh={handleRefresh}
        />
      </Card>

      <FeatureDefinitionWizard
        open={wizardOpen}
        onClose={handleWizardClose}
        onSuccess={handleWizardSuccess}
        editMode={editMode}
        initialData={selectedFeature}
      />
    </div>
  )
}
